module.exports = __webpack_public_path__ + "img/small_banner.76b18868.png";